import * as React from 'react'
import {
    AddFilled,
    AddRegular,
    ArrowDownloadFilled,
    ArrowDownloadRegular,
    bundleIcon,
    DualScreenClockFilled,
    DualScreenClockRegular,
} from '@fluentui/react-icons'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Tooltip } from '@fluentui/react-components'
import { parseFilterValuesToParams } from '../../../pages/BaseOverview/BaseOverview'
import useRoles, { Role } from '../../../hooks/useRoles'
import useSubmitDocumentGenerationRequest from '../../../hooks/finance/report/useSubmitDocumentGenerationRequest'
import { DocumentGenerationType } from '../../../hooks/document/useDocumentGenerationHandler'
import { useFormikContext } from 'formik'
import { BaseTimeOverviewProps, ExtendedTimeOverviewDto, TimeFilterType, TimeOverviewCount, TimeSortingType } from './BaseTimeOverview'
import { BaseOverviewFilterProps } from '../../../pages/BaseOverview/BaseOverviewFilter'
import { BaseMutableOverviewActionButtonProps } from '../../../pages/BaseMutableOverview/BaseMutableOverview'

const AddIcon = bundleIcon(AddFilled, AddRegular)
const TimeSuggestionIcon = bundleIcon(DualScreenClockFilled, DualScreenClockRegular)
const DownloadIcon = bundleIcon(ArrowDownloadFilled, ArrowDownloadRegular)

export default function HeaderActionsButtons(
    props: BaseOverviewFilterProps<
        ExtendedTimeOverviewDto,
        TimeFilterType,
        TimeSortingType,
        TimeOverviewCount,
        BaseMutableOverviewActionButtonProps<any>
    >,
) {
    const history = useHistory()
    const roles = useRoles()
    const { t: translate } = useTranslation()
    const { values } = useFormikContext<TimeFilterType>()

    const submitReportRequest = useSubmitDocumentGenerationRequest<TimeFilterType>(DocumentGenerationType.TimeXls)
    const timeProps = props as unknown as BaseTimeOverviewProps

    return (
        <>
            <Tooltip withArrow relationship={'label'} content={translate('action.create.time.title')}>
                <Button icon={<AddIcon />} appearance={'primary'} onClick={() => props.setOpenMutationDialog(true, null)} />
            </Tooltip>
            <Tooltip withArrow relationship={'label'} content={translate('action.time.suggestion.title')}>
                <Button icon={<TimeSuggestionIcon />} appearance={'secondary'} onClick={() => history.push(`${timeProps.baseUrl}/suggestion`)} />
            </Tooltip>
            {roles.all([Role.Report]) && (
                <Tooltip withArrow relationship={'label'} content={translate('action.download.selection')}>
                    <Button icon={<DownloadIcon />} appearance={'secondary'} onClick={() => submitReportRequest(parseFilterValuesToParams(values))} />
                </Tooltip>
            )}
        </>
    )
}
